<template>
  <a-layout>
    <a-layout-content style="background-color:white">
      <a-row class="vd-toolbar">
        <a-col class="vd-toolbar-right vd-bar">
          <a-form layout="inline">
            <a-form-item>
              <a-tooltip title="时间区间">
                <a-range-picker
                  :default-value="defaultTime"
                  format="YYYY/MM/DD"
                  @change="dateChange"
                />
              </a-tooltip>
            </a-form-item>
            <a-form-item>
              <a-tooltip title="搜索数据">
                <a-button
                  style="margin-right: 8px"
                  @click="getData"
                  type="primary"
                  icon="search"
                />
              </a-tooltip>
              <a-button icon="export" @click="exportData">导出数据</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]">
        <a-col :span="24">
          <a-card title="粉丝统计" :bordered="true">
            <div id="fansChart" style="height: 300px"></div>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]">
        <a-col :span="24">
          <a-card title="消息统计" :bordered="true">
            <div id="messageChart" style="height: 300px"></div>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]">
        <a-col :span="24">
          <a-card title="作品分析" :bordered="true">
            <div id="contentChart" style="height: 300px"></div>
          </a-card>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
import moment from 'moment'
import * as echarts from 'echarts'
import { chart_data } from '@/api/tik'
import XLSX from 'xlsx'

export default {
  name: 'DetailMonth',
  data() {
    return {
      defaultTime: [moment().startOf('month'), moment().endOf('month')],
      // -------------
      id: 0,
      list: [],
      fansChart: null,
      messageChart: null,
      contentChart: null,
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  mounted() {
    this.fansChart = echarts.init(document.getElementById('fansChart'))
    this.messageChart = echarts.init(document.getElementById('messageChart'))
    this.contentChart = echarts.init(document.getElementById('contentChart'))
    this.getData()
  },
  methods: {
    drawFans(d, newFans, totalFans) {
      // 绘制图表
      this.fansChart.setOption({
        title: false,
        tooltip: { trigger: 'axis' },
        legend: {
          data: ['净增', '总量'],
          selected: { 总量: false },
        },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: d },
        yAxis: { type: 'value' },
        series: [
          {
            name: '净增',
            type: 'line',
            stack: '量',
            smooth: true,
            data: newFans,
          },
          {
            name: '总量',
            type: 'line',
            stack: '量2',
            smooth: true,
            data: totalFans,
          },
        ],
      })
      this.fansChart.resize()
    },
    drawMessage(d, comment, like, share, uv) {
      // 绘制图表
      this.messageChart.setOption({
        title: false,
        tooltip: { trigger: 'axis' },
        legend: { data: ['评论数', '点赞数', '分享数', '个人主页访问数'] },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: d },
        yAxis: { type: 'value' },
        series: [
          {
            name: '评论数',
            type: 'line',
            stack: '量',
            smooth: true,
            data: comment,
          },
          {
            name: '点赞数',
            type: 'line',
            stack: '量2',
            smooth: true,
            data: like,
          },
          {
            name: '分享数',
            type: 'line',
            stack: '量3',
            smooth: true,
            data: share,
          },
          {
            name: '个人主页访问数',
            type: 'line',
            stack: '量4',
            smooth: true,
            data: uv,
          },
        ],
      })
      this.messageChart.resize()
    },
    drawContent(d, issue, play, totalIssue) {
      // 绘制图表
      this.contentChart.setOption({
        title: false,
        tooltip: { trigger: 'axis' },
        legend: { data: ['今日发布数', '总播放数', '视频总数'] },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: d },
        yAxis: { type: 'value' },
        series: [
          {
            name: '今日发布数',
            type: 'line',
            stack: '量2',
            smooth: true,
            data: issue,
          },
          {
            name: '总播放数',
            type: 'line',
            stack: '量3',
            smooth: true,
            data: play,
          },
          {
            name: '视频总数',
            type: 'line',
            stack: '量4',
            smooth: true,
            data: totalIssue,
          },
        ],
      })
      this.contentChart.resize()
    },
    getData() {
      chart_data({
        id: this.id,
        dateRange: this.defaultTime,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.drawFans(res.date, res.fans_new_fans, res.fans_total_fans)
          this.drawMessage(
            res.date,
            res.new_comment,
            res.new_like,
            res.new_share,
            res.profile_uv
          )
          this.drawContent(
            res.date,
            res.video_new_issue,
            res.video_new_play,
            res.video_total_issue
          )
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    dateChange(dates) {
      this.defaultTime = dates
    },
    exportData() {
      const ws = XLSX.utils.json_to_sheet(this.list)
      let workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, ws, 'SheetJS')

      XLSX.writeFile(workbook, 'tik_data.xlsx', {
        type: 'base64',
        bookType: 'xlsx',
      })
    },
  },
}
</script>

<style scoped></style>
